import React from "react";
import {connect} from "react-redux";
import {FixedDropDownButton, Icon, modal, utils, commons, Loader} from "@mc/mc-legacy";
import GroupMenu from "../components/GroupMenu";
import CustomPageLayout from "./CustomPageLayout";
import * as actions from "../actions/prePozadavkyNevyrizeneActions";
import * as pdfViewerActions from "../actions/pdfViewerActions";
import {Col, DropdownItem, Row} from "reactstrap";
import SignPreRequestInfoData from "../components/SignPreRequestInfoData";
import SignRequestTitle from "../components/SignRequestTitle";
import signRequestInternalApi from "../api/gen/qsign/SignRequestInternalApi";
import * as groupMenuActions from "../actions/groupMenuActions";
import * as pozadavkyActions from "../actions/prePozadavkyActions";
import EnumState from "../api/gen/qsign/types/EnumState";
import MessageEmptyList from "../components/MessageEmptyList";
import "./CustomItem.scss";
import ItemListFixed from "../components/ItemListFixed";
import PrilohyButton from "../components/PrilohyButton";
import SignRequestInternalApi from "../api/gen/qsign/SignRequestInternalApi";
import PreNovyPozadavekForm from "../components/forms/PreNovyPozadavekForm";
import TypeSign from "../api/gen/qsign/types/TypeSign";
import PreRequestVO from "../api/gen/qsign/types/PreRequestVO";

const {sinkEvent} = commons;

/**
 * Předběžné nevyřízené požadavky page.
 */
class PrePozadavkyNevyrizenePage extends React.Component {
    componentDidMount() {
        this.fetchData(this.props, true);
        this.handleFilter();
    }

    handleFilter() {
        const {filterList} = this.props;
        this.props.dispatch(pozadavkyActions.filter({...filterList.filter, stateList: [EnumState.INIT]}));
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.fetchData(nextProps, false);
    }

    fetchData = (props, forceFetch) => {
        const {dispatch} = props;
        dispatch(actions.fetchIfNeeded(forceFetch));

        if (forceFetch) {
            dispatch(groupMenuActions.invalidate());
        }
    };
    handleZobrazit = (signRequest, type, viewMode) => {
        this.props.dispatch(
            pdfViewerActions.showDocuments(
                signRequest,
                false,
                type,
                () => {
                    this.fetchData(this.props, true);
                },
                viewMode
            )
        );
    };
    handleStorno = (signRequest: PreRequestVO) => {
        const {dispatch} = this.props;
        dispatch(
            modal.ModalActions.showConfirm(
                "Potvrzení stornování",
                "Opravdu chcete předběžný požadavek stornovat?",
                () =>
                    signRequestInternalApi.stornoPreSignRequest(signRequest.id).then(() => {
                        this.fetchData(this.props, true);
                    }),
                null,
                "Stornovat"
            )
        );
    };
    handleCloseAction = () => {
        this.fetchData(this.props, true)
    }
    createRequestByPre = (preRequest: PreRequestVO) => {
        const {dispatch, history} = this.props;
        dispatch(actions.createRequestByPre(preRequest, history, this.handleCloseAction));
    };
    renderItem = (item: PreRequestVO) => {
        return (
            <div className="custom-item">
                <div className="custom-item-content">
                    <Row noGutters className="ml-3">
                        <Col xs={12}>
                            <SignRequestTitle
                                onClick={() => actions.createRequestByPre(item)}
                                signRequest={item}
                                customRender={(item) => {
                                    if (item.attachmentCount > 0) {
                                        return <PrilohyButton attachmentCount={item.attachmentCount} itemID={item.id}/>;
                                    }
                                }}
                            />
                        </Col>
                        <Col>
                            <SignPreRequestInfoData signRequest={item} />
                        </Col>
                    </Row>
                </div>
                <div className="custom-item-action">
                    {this.renderActions(item)}
                </div>
            </div>
        );
    };
    renderActions = (item: PreRequestVO) => {
        return (
            <div className="actions actions-button">
                <FixedDropDownButton
                    onClick={sinkEvent}
                    color="action"
                    noCaret
                    title={<Icon icon="ellipsis-v" className="action-ellipsis"/>}
                >
                    <DropdownItem key="0"
                                  onClick={() => this.createRequestByPre(item)}>
                        Založit požadavek
                    </DropdownItem>
                    {/*{item.waitingDocuments > 0 && (*/}
                        <DropdownItem key="1" onClick={() => this.handleStorno(item)}>
                            Stornovat požadavek
                        </DropdownItem>
                    {/*)}*/}
                </FixedDropDownButton>
            </div>
        );
    };

    render() {
        const {itemList} = this.props;
        const listProps = {
            itemList,
            loadMore: actions.loadMore,
            invalidatePozadavky: actions.invalidate,
            renderItem: this.renderItem,
            emptyList: (
                <MessageEmptyList>
                    <div className="message">
                        Žádné nevyřízené předběžné požadavky
                        <div className="thumbup">
                            <Icon icon="thumbs-o-up fa-4x"/>
                        </div>
                    </div>
                </MessageEmptyList>
            ),
        };
        return (
            <CustomPageLayout
                header
                onCloseAction={() => this.fetchData(this.props, true)}
                title="Nevyřízené předběžné požadavky"
                menu={<GroupMenu/>}
            >
                <ItemListFixed {...listProps} />
            </CustomPageLayout>
        );
    }
}

function mapStateToProps(state) {
    return {
        itemList: utils.storeFromArea(state, actions.PRE_POZADAVEK_NEVYRIZENE_LIST),
        filterList: utils.storeFromArea(state, pozadavkyActions.PRE_POZADAVKY_SEARCH_LIST),
    };
}

export default connect(mapStateToProps)(PrePozadavkyNevyrizenePage);
